import DataTable from "../../../../views/Tables/DataTable";
import Card from "@mui/material/Card";
import DefaultCell from "../../../../components/DataTable/DefaultCell";
import StatusCell from "../../../../components/DataTable/StatusCell";
import { useGetPhotoSearchesQuery } from "../../../../store/api/ai";
import { useEffect, useState } from "react";
import MDBox from "../../../../components/MDBox";
import BaseLayout from "../../account/components/BaseLayout";
import { parseISO } from "date-fns";
import CustomerCell from "../../../../components/DataTable/CustomerCell";
import Gallery from "react-grid-gallery";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import MDTypography from "../../../../components/MDTypography";

// const dataTableData = {
//   columns,
//   rows: [
//     {
//       id: "#10421",
//       date: "1 Nov, 10:20 AM",
//       status: "paid",
//       customer: ["Orlando Imieto", { image: eventDefault }],
//       product: "Nike Sport V2",
//       revenue: "$140,20",
//     },
//     {
//       id: "#10422",
//       date: "1 Nov, 10:53 AM",
//       status: "paid",
//       customer: ["Alice Murinho", { image: eventDefault }],
//       product: "Valvet T-shirt",
//       revenue: "$42,00",
//     },
//     {
//       id: "#10423",
//       date: "1 Nov, 11:13 AM",
//       status: "refunded",
//       customer: ["Michael Mirra", { image: "M" }],
//       product: ["Leather Wallet", { suffix: "+1 more" }],
//       revenue: "$25,50",
//     },
//     {
//       id: "#10424",
//       date: "1 Nov, 12:20 PM",
//       status: "paid",
//       customer: ["Andrew Nichel", { image: eventDefault }],
//       product: "Bracelet Onu-Lino",
//       revenue: "$19,40",
//     },
//     {
//       id: "#10425",
//       date: "1 Nov, 1:40 PM",
//       status: "canceled",
//       customer: ["Sebastian Koga", { image: eventDefault }],
//       product: ["Phone Case Pink", { suffix: "x 2" }],
//       revenue: "$44,90",
//     },
//     {
//       id: "#10426",
//       date: "1 Nov, 2:19 PM",
//       status: "paid",
//       customer: ["Laur Gilbert", { image: "L" }],
//       product: "Backpack Niver",
//       revenue: "$112,50",
//     },
//     {
//       id: "#10427",
//       date: "1 Nov, 3:42 AM",
//       status: "paid",
//       customer: ["Iryna Innda", { image: "I" }],
//       product: "Adidas Vio",
//       revenue: "$200,00",
//     },
//     {
//       id: "#10428",
//       date: "2 Nov, 9:32 AM",
//       status: "paid",
//       customer: ["Arrias Liunda", { image: "A" }],
//       product: "Airpods 2 Gen",
//       revenue: "$350,00",
//     },
//     {
//       id: "#10429",
//       date: "2 Nov, 10:14 AM",
//       status: "paid",
//       customer: ["Rugna Ilpio", { image: eventDefault }],
//       product: "Bracelet Warret",
//       revenue: "$15,00",
//     },
//     {
//       id: "#10430",
//       date: "2 Nov, 10:14 AM",
//       status: "refunded",
//       customer: ["Anna Landa", { image: eventDefault }],
//       product: ["Watter Bottle India", { suffix: "x 3" }],
//       revenue: "$25,00",
//     },
//     {
//       id: "#10431",
//       date: "2 Nov, 3:12 PM",
//       status: "paid",
//       customer: ["Karl Innas", { image: "K" }],
//       product: "Kitchen Gadgets",
//       revenue: "$164,90",
//     },
//     {
//       id: "#10432",
//       date: "2 Nov, 5:12 PM",
//       status: "paid",
//       customer: ["Oana Kilas", { image: "O", color: "info" }],
//       product: "Office Papers",
//       revenue: "$23,90",
//     },
//   ],
// };


const SearchList = () => {
  const { data, isLoading, error } = useGetPhotoSearchesQuery("",{
    pollingInterval: 5000,
  });
  const [dataTable, setDataTable] = useState();

  const columns = [
    {
      Header: "Images",
      accessor: "id",
      Cell: ({ value }) => <IconButton
        onClick={() => setActiveSearch(value)}><Icon>arrow_circle_right</Icon></IconButton>
    },
    {
      Header: "event name",
      accessor: "event_name",
      Cell: ({ value: [name, data] }) => (
        <CustomerCell image={data.cover} color={data.color || "dark"} name={name} />
      )
    },
    {
      Header: "first name",
      accessor: "first_name",
      Cell: ({ value }) => <DefaultCell value={value} />
    },
    {
      Header: "last name",
      accessor: "last_name",
      Cell: ({ value }) => <DefaultCell value={value} />
    },
    {
      Header: "Started at",
      accessor: "search_started_at",
      Cell: ({ value }) => <DefaultCell value={value} />
    },
    {
      Header: "Completed at",
      accessor: "search_completed_at",
      Cell: ({ value }) => <DefaultCell value={value} />
    },
    {
      Header: "status",
      accessor: "status",
      Cell: ({ value }) => {
        let status;

        if (value === "0") {
          status = <StatusCell icon="replay" color="dark" status="Pending" />;
        } else if (value === "1") {
          status = <StatusCell icon="thumb_up" color="warning" status="Accepted" />;
        } else if (value === "2") {
          status = <StatusCell icon="done" color="success" status="Completed" />;
        } else {
          status = <StatusCell icon="close" color="error" status="Canceled" />;
        }
        return status;
      }
    },
    {
      Header: "founded image length",
      accessor: "image_length",
      Cell: ({ value }) => <DefaultCell value={value} />
    }
  ];

  const [activeSearch, setActiveSearch] = useState();

  useEffect(() => {
    if (activeSearch) {
      const images_r = data?.results?.find(s => s.id.toString() === activeSearch).search_result.filter(v => v.watermark !== null).map(v => ({
        id: v.photo_id,
        thumbnail: v.thumb,
        src: v.watermark,
        thumbnailWidth: parseInt(v.thumb_ratio * 240),
        thumbnailHeight: 240
      }));
      setImages(images_r);
    }
  }, [activeSearch]);

  useEffect(() => {
    const res = data?.results.map(d => ({
      id: d.id.toString(),
      event_name: [d.event.name, { cover: d.event.cover }],
      first_name: d.owner.first_name,
      last_name: d.owner.last_name,
      search_started_at: d.search_started_at ? parseISO(d.search_started_at).toLocaleString() : "",
      search_completed_at: d.search_completed_at ? parseISO(d.search_completed_at).toLocaleString() : "",
      status: d.status.toString(),
      image_length: d.search_result.length > 0 ? d.search_result.length.toString() : "-"
    }));
    setDataTable({
      columns,
      rows: res
    });
  }, [data]);

  const [images, setImages] = useState();


  return (
    <BaseLayout>
      <MDBox my={3}>
        <Card>
          {dataTable && dataTable.rows && <DataTable table={dataTable} entriesPerPage={false} canSearch />}
        </Card>
      </MDBox>
      {images &&
      <MDBox my={3}>
        <MDTypography variant="h3" fontWeight="medium" mt={1}>
          Founded Images
        </MDTypography>
        <Card>
          <Gallery images={images}
                   backdropClosesModal={true}
                   showLightboxThumbnails={true}

          />
        </Card>
      </MDBox>}
    </BaseLayout>
  );

};

export default SearchList;
